import { render, staticRenderFns } from "./tenderType.vue?vue&type=template&id=11a4a6dc"
import script from "./tenderType.vue?vue&type=script&lang=js"
export * from "./tenderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports